import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Prefer the WordPress shortcode container if present, otherwise fall back to CRA's #root.
const mountNode =
  document.getElementById('carbon-calculator-root') ||
  document.getElementById('root');

if (!mountNode) {
  // Fail fast to help debugging when the container is missing.
  // In WordPress, ensure the shortcode renders: <div id="carbon-calculator-root"></div>
  // In local dev, ensure public/index.html has <div id="root"></div>
  throw new Error('Mount node not found: #carbon-calculator-root or #root');
}

const root = createRoot(mountNode);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: performance metrics
// e.g., reportWebVitals(console.log)
reportWebVitals();
